export function showCommerceIcon({ playerConfig }: any) {
  const container = document.getElementById('shopIconContainer');
  if (!container) {
    const shopIconContainer = document.createElement('div');
    shopIconContainer.setAttribute('id', 'shopIconContainer');
    const shopIconContainerClassList = shopIconContainer.classList;
    shopIconContainerClassList.add('shopIconContainer');
    shopIconContainer.addEventListener(
      'click',
      playerConfig?.onClickCommerceIcon
    );
    const logo = document.createElement('span');
    logo.setAttribute('class', 'shopIcon');
    shopIconContainer.appendChild(logo);
    const videoPlayer = document.getElementById('video-tag');
    videoPlayer?.appendChild(shopIconContainer);
  }
}

export function adjustShopIconContainer(remove = false) {
  const shopIconContainer = document.getElementById('shopIconContainer');
  const chromeCastBtnContainer = document.getElementById(
    'chromeCastBtnContainer'
  );
  const isChromeCastBtnContainerPresent = chromeCastBtnContainer?.nextSibling;
  const chromeCastBtnContainerClassList = chromeCastBtnContainer?.classList;
  const isCommerceContainerPresent = shopIconContainer?.nextSibling;
  const shopIconContainerClassList = shopIconContainer?.classList;
  if (isCommerceContainerPresent) {
    remove
      ? shopIconContainerClassList?.remove('adjustShopIconContainer')
      : shopIconContainerClassList?.add('adjustShopIconContainer');
  }
  if (isChromeCastBtnContainerPresent) {
    remove
      ? chromeCastBtnContainerClassList?.remove('adjustChromeCastIconContainer')
      : chromeCastBtnContainerClassList?.add('adjustChromeCastIconContainer');
  }
}

export function adjustShopIconContainerOnChromecast(add = false) {
  const shopIconContainer = document.getElementById('shopIconContainer');
  const shopIconContainerClassList = shopIconContainer?.classList;
  if (shopIconContainerClassList && shopIconContainerClassList.length) {
    add
      ? shopIconContainerClassList?.add('adjustShopIconContainerOnChromecast')
      : shopIconContainerClassList?.remove(
          'adjustShopIconContainerOnChromecast'
        );
  }
}

export function hideCommerceIcon() {
  const container = document.querySelector('.shopIconContainer');
  if (container) {
    container.remove();
  }
}
